<template>
<div class="spannels">
  <div class="spannel scolor01">
    <span>文章总量:</span><br>
    <em>{{obj1.total_count}}</em><span>人</span><br>
    <span style="font-size: 12px;">
      周同比
      <img v-if='obj1.week_percent>0' src="static/images/up.png" width="10" alt="">
      <img v-else src="static/images/down.png" style="transform: rotate(180deg);" width="10" alt="">
      {{obj1.week_percent}}%
    </span>
    <span style="font-size: 12px;">
      日环比
      <img v-if='obj1.day_percent>0' src="static/images/up.png" width="10" alt="">
      <img v-else src="static/images/down.png" style="transform: rotate(180deg);" width="10" alt="">
      {{obj1.day_percent}}%
    </span>
  </div>
  <div class="spannel scolor02">
    <span>评论数:</span><br>
    <em>{{obj2.total_count}}</em><span>人</span><br>
    <span style="font-size: 12px;">
      周同比
      <img v-if='obj2.week_percent>0' src="static/images/up.png" width="10" alt="">
      <img v-else src="static/images/down.png" style="transform: rotate(180deg);" width="10" alt="">
      {{obj2.week_percent}}%
    </span>
    <span style="font-size: 12px;">
      日环比
      <img v-if='obj2.day_percent>0' src="static/images/up.png" width="10" alt="">
      <img v-else src="static/images/down.png" style="transform: rotate(180deg);" width="10" alt="">
      {{obj2.day_percent}}%
    </span>
  </div>
  <div class="spannel scolor03">
    <span>阅读量:</span><br>
    <em>{{obj3.total_count}}</em><span>人</span><br>
    <span style="font-size: 12px;">
      周同比
      <img v-if='obj3.week_percent>0' src="static/images/up.png" width="10" alt="">
      <img v-else src="static/images/down.png" style="transform: rotate(180deg);" width="10" alt="">
      {{obj3.week_percent}}%
    </span>
    <span style="font-size: 12px;">
      日环比
      <img v-if='obj3.day_percent>0' src="static/images/up.png" width="10" alt="">
      <img v-else src="static/images/down.png" style="transform: rotate(180deg);" width="10" alt="">
      {{obj3.day_percent}}%
    </span>
  </div>
  <div class="spannel scolor04">
    <span>转发数:</span><br>
    <em>{{obj4.total_count}}</em><span>人</span><br>
    <span style="font-size: 12px;">
      周同比
      <img v-if='obj4.week_percent>0' src="static/images/up.png" width="10" alt="">
      <img v-else src="static/images/down.png" style="transform: rotate(180deg);" width="10" alt="">
      {{obj4.week_percent}}%
    </span>
    <span style="font-size: 12px;">
      日环比
      <img v-if='obj4.day_percent>0' src="static/images/up.png" width="10" alt="">
      <img v-else src="static/images/down.png" style="transform: rotate(180deg);" width="10" alt="">
      {{obj4.day_percent}}%
    </span>
  </div>
</div>
</template>

<script>
import cons from '@/components/constant'
export default {
  name: 'CountPannel',
  data(){
    return {
      obj1: {
        day_average: 0,
        day_count: 0,
        day_percent: 0,
        total_count: 0,
        total_days: 0,
        week_percent: 0
      },
      obj2: {
        day_average: 0,
        day_count: 0,
        day_percent: 0,
        total_count: 0,
        total_days: 0,
        week_percent: 0
      },
      obj3: {
        day_average: 0,
        day_count: 0,
        day_percent: 0,
        total_count: 0,
        total_days: 0,
        week_percent: 0
      },
      obj4: {
        day_average: 0,
        day_count: 0,
        day_percent: 0,
        total_count: 0,
        total_days: 0,
        week_percent: 0
      }

    }
  },
  mounted(){
    let token = localStorage.token;

    // 获取文章
    this.axios.get(cons.apis + '/v1_0/statistics_basic', {
        headers: {
          'Authorization': 'Bearer ' + token
        },
        responseType: 'json',
        params:{
          type: 'article'
        }
    })
    .then(dat=>{
        // console.log(dat);
        this.obj1 = dat.data.data;
    }).catch(err=>{
       console.log(err.response);
       // if(err.response.status==401){
       //    this.$router.push({path:'/'});
       // }
    });


    // 获取访问量
    this.axios.get(cons.apis + '/v1_0/statistics_basic', {
        headers: {
          'Authorization': 'Bearer ' + token
        },
        responseType: 'json',
        params:{
          type: 'comment'
        }
    })
    .then(dat=>{
        // console.log(dat);
        this.obj2 = dat.data.data;
    }).catch(err=>{
       console.log(err.response);
    });

    // 获取阅读量
    this.axios.get(cons.apis + '/v1_0/statistics_basic', {
        headers: {
          'Authorization': 'Bearer ' + token
        },
        responseType: 'json',
        params:{
          type: 'read'
        }
    })
    .then(dat=>{
        // console.log(dat);
        this.obj3 = dat.data.data;
    }).catch(err=>{
       console.log(err.response);
    });

    // 获取转发量
    this.axios.get(cons.apis + '/v1_0/statistics_basic', {
        headers: {
          'Authorization': 'Bearer ' + token
        },
        responseType: 'json',
        params:{
          type: 'forward'
        }
    })
    .then(dat=>{
        // console.log(dat);
        this.obj4 = dat.data.data;
    }).catch(err=>{
       console.log(err.response);
    });



  }
}
</script>

<style scoped>
.spannel{
  width:22%;
  float:left;
  margin-left:2.4%;
  height:110px;
  overflow:hidden;
  padding-top: 10px;
  position:relative;
}
.spannel em{
  font-size:24px;
  line-height:46px;
  display:inline-block;
  margin:10px 0 0 10px;
  font-family:'Arial';
  color:rgba(0,0,0,0.8);
}
.spannel span{
  font-size:14px;
  display:inline-block;
  /*color:rgba(0,0,0,0.8);*/
  color: #aaa;
  /*color:rgba(255,255,255,0.8);*/
  margin-left:10px;
}
.scolor01{
  background-color:#fff;
}
.scolor02{
  background-color:#fff;
}
.scolor03{
  background-color:#fff;
}
.scolor04{
  background-color:#fff;
}
.spannels{
  overflow:hidden;
  margin:20px auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/widget/CountPannelTwo.vue